exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MuiSlider-markLabel {\n    color: #ffffff;\n  }\n\n.float-container {\n    /* border: 3px solid #fff; */\n    padding: 0px;\n    display: flex;\n    align-items: center;\n}\n\n.float-child {\n    width: 33%;\n    float: left;\n    /* padding: 20px; */\n    /* border: 2px solid red; */\n}  \n\n.flexbox{\n    display: flex;\n    flex-direction: column;\n}\n\n.title{\n    font-size: 1.3vw;\n}", ""]);

// exports
